var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "field",
          {
            attrs: {
              "edit-visibility": _vm.editVisibility,
              "visibility-paths": [_vm.visibilityPaths.interestRate],
              "size-class": "col-lg-4 col-md-6 col-12",
              title: _vm.$t("application-form.interest-rate"),
              "container-class": "perc-append",
            },
            on: { "toggle-visibility": _vm.handleVisibility },
          },
          [
            _c("text-section", {
              attrs: {
                name: "interest-rate",
                placeholder: "0.00",
                "class-name": "rate",
                tabindex: "1400",
                label: _vm.$t("application-form.interest-rate"),
              },
              model: {
                value: _vm.interestRate,
                callback: function ($$v) {
                  _vm.interestRate = $$v
                },
                expression: "interestRate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          {
            attrs: {
              "size-class": "col-lg-8 col-md-6 col-12",
              title: _vm.$t("application-form.amortization"),
              "edit-visibility": _vm.editVisibility,
              "visibility-paths": [
                _vm.visibilityPaths.amortizationYears,
                _vm.visibilityPaths.amortizationMonths,
              ],
            },
            on: { "toggle-visibility": _vm.handleVisibility },
          },
          [
            _c("years-months-section", {
              attrs: {
                placeholder: _vm.$t("application-form.amortization"),
                name: "amortization",
                "class-name": "fe-num-field",
                disabled: _vm.interestOnly,
                "force-zero-placeholder": "",
                tabindex: "1400",
              },
              model: {
                value: _vm.amortizationYearsAndMonths,
                callback: function ($$v) {
                  _vm.amortizationYearsAndMonths = $$v
                },
                expression: "amortizationYearsAndMonths",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row align-items-center" },
      [
        _c(
          "field",
          {
            attrs: {
              "edit-visibility": _vm.editVisibility,
              "visibility-paths": [_vm.visibilityPaths.compoundedPeriod],
              "size-class": "col-lg-4 col-md-6 col-12 radio-field",
              title: _vm.$t("application-form.compounding-period"),
            },
            on: { "toggle-visibility": _vm.handleVisibility },
          },
          [
            _c("radio-section", {
              attrs: {
                name:
                  "compounded-period-qualifying-details-" + _vm.mortgageIndex,
                options: _vm.compoundingPeriodOptions,
                tabindex: "1400",
              },
              model: {
                value: _vm.compoundedPeriod,
                callback: function ($$v) {
                  _vm.compoundedPeriod = $$v
                },
                expression: "compoundedPeriod",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          {
            attrs: {
              "size-class": "ml-3",
              "edit-visibility": _vm.editVisibility,
              "visibility-paths": [_vm.visibilityPaths.interestOnly],
              title: _vm.editVisibility
                ? _vm.$t("application-form.interest-only")
                : "",
            },
            on: { "toggle-visibility": _vm.handleVisibility },
          },
          [
            _c("checkbox-section", {
              attrs: {
                name: "interest-only-qualifying-details-" + _vm.mortgageIndex,
                label: _vm.editVisibility
                  ? ""
                  : _vm.$t("application-form.interest-only"),
                tabindex: "1400",
              },
              model: {
                value: _vm.interestOnly,
                callback: function ($$v) {
                  _vm.interestOnly = $$v
                },
                expression: "interestOnly",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }